export const expirationSession = (props, t, navigation) => {
  props.SetLoginFormError({
    errorStatus: true,
    content: t("PortalMessages.Error.SessionExpired"),
  });
  navigation("/Login");
};
